<template>
  <div class="row pr-4">
    <div class="col-12">
      <PageTitle title="PRÊMIOS SOLICITADOS" />
    </div>

    <div class="col-12 mt-2">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">Foto</th>
            <th>Nome do prêmio</th>
            <th>Cliente</th>
            <th class="text-center">CPF/CNPJ</th>
            <th class="text-center">Status</th>
            <th class="text-center">Solicitado</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in premios" :key="i" v-show="premios.length > 0">
            <td class="text-center align-middle">
              <img :src="formatarUrlImagrm(item.fotos[0])" :alt="item.nome_premio" width="50px">
            </td>

            <td class="align-middle">
              {{ item.nome_premio }}
            </td>

            <td class="align-middle">
              {{ formatarDados(item.cliente, 'nome') }}
            </td>

            <td class="text-center align-middle">
              {{ formatarDados(item.cliente, 'documento') }}
            </td>

            <td class="text-center align-middle">
              <h6 v-if="item.statusSolicitado == 1">
                <span class="badge badge-warning">{{item.statusSolicitadoText}}</span>
              </h6>

              <h6 v-if="item.statusSolicitado == 2">
                <span class="badge badge-success">{{item.statusSolicitadoText}}</span>
              </h6>

              <h6 v-if="item.statusSolicitado == 3">
                <span class="badge badge-danger">{{item.statusSolicitadoText}}</span>
              </h6>
            </td>

            <td class="text-center align-middle">
              {{ formatarData(item.created_at) }}
            </td>

            <td class="text-center align-middle">              
              <button class="btn btn-primary" v-b-tooltip.hover title="Visualizar" @click="Visualizar(item)">
                <i class="fas fa-search"></i>
              </button>
              
              <button 
                class="btn btn-success mr-2 ml-2" 
                v-b-tooltip.hover 
                title="Aprovar" 
                v-if="item.statusSolicitado == 1"
                @click="updateStatus(item.premio_solicitado_id, 4)"
              >
                <i class="fas fa-check"></i>
              </button>

              <button 
                class="btn btn-danger" 
                v-b-tooltip.hover 
                title="Cancelar" 
                v-if="item.statusSolicitado == 1"
                @click="updateStatus(item.premio_solicitado_id, 3)"
              >
                <i class="fas fa-ban"></i>
              </button>
            </td>
          </tr>
          <tr v-show="premios.length == 0">
            <td colspan="8" class="text-center">
              <span>Você não tem prêmio(s) solicitado(s)!</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

     <b-modal
        :title="produto != null ? produto.nome_premio : ''"
        size="xl"
        id="modal-meus-premios"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-footer
      >
        <b-row v-if="produto != null">
          <b-col cols="5" class="slideImg">
            <b-carousel
              style="text-shadow: 0px 0px 2px #000"
              indicators
              img-width="600"
              img-height="600"
              controls
              sliding-start
              sliding-end
              v-if="produto.fotos.length > 0"
            >
              <b-carousel-slide
                v-for="(item, i) in produto.fotos"
                :key="i"
                :img-src="formatarUrlImagrm(item)"
              ></b-carousel-slide>
            </b-carousel>

            <div v-else>
              <h1>Sem imagens</h1>
            </div>
          </b-col>

          <b-col cols="7">
            <b-row>
              <b-col cols="3">
                <label>Status</label>
                <h6 v-if="produto.statusSolicitado == 1">
                  <span class="badge badge-warning">{{produto.statusSolicitadoText}}</span>
                </h6>

                <h6 v-if="produto.statusSolicitado == 2">
                  <span class="badge badge-success">{{produto.statusSolicitadoText}}</span>
                </h6>

                <h6 v-if="produto.statusSolicitado == 3">
                  <span class="badge badge-danger">{{produto.statusSolicitadoText}}</span>
                </h6>
              </b-col>

              <b-col cols="4">
                <label>Pontos cobrados pelo prêmio</label>
                <h6>
                  <span class="badge badge-warning">{{produto.pontoSolicitado}} pontos</span>
                </h6>
              </b-col>

              <b-col cols="5">
                <label>Camapnha</label>
                <h6>
                  <span class="badge badge-warning">{{produto.nome_campanha}}</span>
                </h6>
              </b-col>

              <b-col cols="8">
                <label>Cliente</label>
                <input type="text" class="form-control" :value="formatarDados(produto.cliente, 'nome')" disabled>
              </b-col>

              <b-col cols="4">
                <label>CPF / CNPJ</label>
                <input type="text" class="form-control" :value="formatarDados(produto.cliente, 'documento')" disabled>
              </b-col>

              <b-col cols="8" class="mt-2">
                <label>E-mail</label>
                <input type="text" class="form-control" :value="produto.cliente.email" disabled>
              </b-col>

              <b-col cols="4" class="mt-2">
                <label>Celular</label>
                <input type="text" class="form-control" :value="produto.cliente.phone != null ? formatarTelefone(produto.cliente.phone[0].number) : '-'" disabled>
              </b-col>

              <b-col 
                cols="6" 
                class="mt-2" 
                v-if="produto.cliente.phone != null && produto.cliente.phone[1] && produto.cliente.phone[1].number"
              >
                <label>Celular 2</label>
                <input type="text" class="form-control" :value="formatarTelefone(produto.cliente.phone[1].number)" disabled>
              </b-col>

              <b-col 
                cols="6" 
                class="mt-2" 
                v-if="produto.cliente.phone != null && produto.cliente.phone[2] && produto.cliente.phone[2].number"
              >
                <label>Celular 3</label>
                <input type="text" class="form-control" :value="formatarTelefone(produto.cliente.phone[2].number)" disabled>
              </b-col>

              <b-col cols="12" class="mt-2">
                <label>Produto</label>
                <input type="text" class="form-control" :value="produto.nome_premio" disabled>
              </b-col>

              <b-col cols="12" class="mt-2">
                <label>Descrição</label>
                <textarea class="form-control" rows="4" :value="produto.descricao" disabled></textarea>
              </b-col>
              
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'PremiosSolicitados',
  mixins: [makeToast],
  components: {
    PageTitle
  },

  data() {
    return {
      premios: [],
      produto: null
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.get();
  },

  methods: {
    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/premioSolicitado', this.dadosUsuario.id)
        .then((response) => {
          this.premios = response.data.premios;
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao buscar seu(s) prêmio(s)!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    updateStatus(id, status) {
      const data = {
        id: id,
        status: status
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/premioSolicitadoAtualizar', data)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso', response.data.message, 'success');

            this.get();
          } else {
            this.makeToast('Erro', response.data.message, 'danger');
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao atualizar status!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    Visualizar(item) {
      this.produto = item;

      this.$bvModal.show('modal-meus-premios');
    },
    formatarDados(cliente, type) {
      if(cliente.type == 1) {
        if(type == 'nome') {
          return cliente.client.first_name +' '+cliente.client.last_name;
        } else {
          return this.formatarCPF(cliente.client.cpf);
        }
      } else if(cliente.type == 2) {
        if(type == 'nome') {
          return cliente.professional.name;
        } else {
          return cliente.professional.cpf != null ? this.formatarCPF(cliente.professional.cpf) : this.formatarCNPJ(cliente.professional.cnpj);
        }
      } else if(cliente.type == 3) {
        if(type == 'nome') {
          return cliente.company.nome_fantasia;
        } else {
          return this.formatarCNPJ(cliente.company.cnpj);
        }
      }
    },
    formatarCPF(cpf) {
      cpf = cpf.replace(/\D/g, '');
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
    formatarCNPJ(cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    },
    formatarTelefone(numero) {
      const numeroLimpo = numero.replace(/\D/g, '');

      const regex = /^(\d{2})(9?\d{4})(\d{4})$/;
      const match = numeroLimpo.match(regex);

      if (match) {
        const formato = match[2].length === 4 ? '($1) $2-$3' : '($1) 9 $2-$3';
        return numeroLimpo.replace(regex, formato);
      }

      return numero;
    },
    formatarUrlImagrm(path) {
      return 'https://construp-imagens.s3.us-east-2.amazonaws.com/premio/'+path.foto;
    },
    contarCaracteres(texto, qtd) {
      var resultado = texto.substring(0, qtd);
      var pontos = texto.length > qtd ? '...' : '';

      return resultado + pontos;
    },
    formatarData(dataHoraOriginal) {
      let dataHora = new Date(dataHoraOriginal);
      let opcoesFormato = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };

      let dataHoraFormatada = new Intl.DateTimeFormat('pt-BR', opcoesFormato).format(dataHora);

      return dataHoraFormatada;
    }
  }
}
</script>

<style scoped>
.statusAtivo {
  background: #3bb53b;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 4px;
}
.statusInativo {
  background: #e71a1a;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 4px;
}
.excluirFoto {
  cursor: pointer;
  background: red;
  color: #FFF;
  border-radius: 3px;
  padding: 0px 4px;
  position: absolute;
  z-index: 9;
  top: -5px;
  right: 25%;
}
.slideImg {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>